<div class="severity-wrapper zk-flex zk-flex-col zk-p-2 zk-gap-2" [ngClass]="'severity-wrapper-' + mode">
	<div *ngIf="mode === 'vc' || mode === 'appointment'" class="zk-flex zk-flex-row zk-gap-1 zk-items-center">
		<p class="severity-title" freud-typography [fontType]="mode === 'appointment' ? 'h5SemiboldAuto' : 'h6SemiboldAuto'">
			{{ 'PROMPTUARY.CGI_SEVERITY.TITLE.' + type | uppercase | translate  }}
		</p>
		<span class="icon-wrapper" (mouseenter)="trackTooltip()" freud-tooltip [tooltipLabel]="'PROMPTUARY.CGI_SEVERITY.TOOLTIP.' + type | uppercase | translate">
			<freud-icon icon="info-circle"></freud-icon>
		</span>
	</div>
	<div class="zk-flex zk-flex-row zk-items-center zk-gap-2">
		<p class="severity-text" freud-typography [fontType]="mode === 'appointment' ? 'h5RegularAuto' : 'bodyRegular1-2'">
			{{ 'PROMPTUARY.CGI_SEVERITY.LABEL' | translate }}
		</p>
		<span class="pill" [attr.level]="severity.level">
			<p class="pill-text" freud-typography [fontType]="mode === 'appointment' ? 'h6RegularAuto' : 'smallSemibold1-5'">
				{{ severity.levelDescription }}
			</p>
		</span>
	</div>
</div>